<template>
    <div class=" s_over_h p-r-40 ">
        <div class="fr s_flex_ali s_bor3 s_over_h">
          <div class="day_active"  :class="{ active: active == 7 }"  @click="active=7;initData()"> 近7天</div>
          <div class="day_active" :class="{ active: active == 30 }" @click="active=30;initData()">近30天</div>
        </div>
      </div>
  <div ref="charts" style="width: 100%; height: 500px"></div>
</template>

<script>
import echarts from "echarts";
import { onMounted, reactive, ref, toRefs } from "vue";
import { activity_scan_statistical } from "@/api/guide";
export default {
  props: {
    echartsData: {
      type: Object,
      default:()=>{}
    },
    type:String,
    activity_id:String
  },
  setup(props) {
    const charts = ref(null);
     let chart;
     let myChart;
     const state=reactive({
         activity_id:'',
         active:7
     })
    onMounted(() => {
        chart = charts.value;
        myChart = echarts.init(chart);
        state.activity_id=props.activity_id
        // renderEcharts();
        initData()
    });
    var initData=async ()=>{
        let result=await activity_scan_statistical(state.activity_id,{day:state.active,type:props.type}).then(res=>res.data).catch(error=>error)
        console.log(result)
        renderEcharts(result.data)
    }
    const renderEcharts = function (echartsData) {
     let option = {
        tooltip: { trigger: "axis" },
        legend: {
          // data:[echartsData.dataName]
          show:false
        },
        xAxis: {
          type: "category",
          data: echartsData.data_time,
          boundaryGap: false, //坐标轴两边不留白
        },
        yAxis: {
          name:'',
          type: "value",
          show:true,
          nameTextStyle:{
              color:'#000',
              fontWeight:800,
              fontSize:14
          }
        },
        grid: {
          y: 80,
          x: 60,
        },
        series: [
          {
            data: echartsData.total,
            type: "line",
            symbolSize: 6,
            smooth: true,
          },

        ],
      }
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });

    
    };
    return {
      charts,
      renderEcharts,
      ...toRefs(state),
      initData
    };
  },
};
</script>
<style lang="less" scoped>
.day_active {
  width: 100px;
  height: 40px;
  background: #fff;
  color: #333;
  border: 1px solid #cecece;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.active {
  background: #143960;
  color: #fff;
  border: none;
  cursor: pointer;
}
.item{
  box-shadow:6px 8px 20px 0 rgba(0,0,0,.3);
  // inset -3px -2px 7px 0 rgb(0 0 0 / 30%)
  border-radius: 10px;
}
</style>